const en = {
  // 导航栏
  navbar: {
    HOME: 'HOME',
    ABOUTUS: 'ABOUT US',
    BUSINESSINTRODUCTION: 'BUSINESS INTRODUCTION',
    LIVERATE: 'LIVE RATE',
    NEWS: 'NEWS',
    CONTACTUS: 'CONTACT US',

    OpenAnAccountOnline: 'Open An Account Online',

    UPDATERATE: 'Bring you up to date on exchange rates',
    CONTACTWAY: 'Contact Way',
    INVITECOOPERATION: 'We sincerely invite cooperation',
    COMPANYNEWS: 'Company News',
    CURRENCYMARKETDYNAMIC: 'In the Currency Market Dynamic'
  },
  // 底部
  footer: {
    CONTACTUS: 'CONTACT US',
    WEBSITENAVIGATION: 'WEBSITE NAVIGATION',
    ABOUTUS: 'ABOUT US',
    OURSERVICES: 'OUR SERVICES',
    NEWS: 'NEWS',
    LIVERATE: 'LIVE RATE',
    CUSTOMERSERVICE: 'CUSTOMER SERVICE',
    WECHAT: 'WECHAT'
  },
  // 首页
  index: {
    SERVICES: 'SERVICES',
    NEWS: 'NEWS',
    GOLDMATENEWS: 'COMPANY NEWS',
    MARKETINSIGHT: 'MARKET INSIGHT',
    KUNDAX: 'KUNDAX',
    GOLDMATE: 'GOLDMATE',
    GOLDMATEGROUP: 'GROUP',
    // KUNDAGROUP:'GROUP'
    KUNDAGROUP: '',
    REASONSFORCHOOSINGUS: 'Reasons For Choosing Us',

    // 实施滚动汇率
    weBuyTt: 'WE BUY TT',
    weSellTt: 'WE SELL TT'
  },
  // 关于我们
  aboutUs: {
    CompanyIntroduction: 'Company Introduction',
    JoinUs: 'Join Us',
    OurPartner: 'Our Partner',
    ABOUTUS: 'ABOUT US',
    OurAdvantages: 'Our Advantages'
  },
  // 主营业务
  services: {
    Remittance: 'Remittance',
    ProductServices: 'Product & Services',
    MoneyLaunderingPolicy: 'Money Laundering Policy',
    PrivacyProtection: 'Privacy Protection',
    Property: 'Property',
    Funding: 'Funding'
  },
  // 资讯详情
  infomationDetail: {
    HotTopics: 'Hot Topics',
    ArticleSearching: 'Article Searching',
    DateSearching: 'Date Searching',
    Prvious: 'Prvious',
    Next: 'Next',
    SearchingArticle: 'Searching Article',
    noResult: 'No related artical, use another key word'
  },
  // 实时汇率
  exchangeRate: {
    ExchangeCalculator: 'Exchange Calculator',
    Sell: 'Sell',
    Buy: 'Buy',
    Rate: '*Please note that the above exchange rate refreshes every two minutes',
    Calculate: 'Calculate',
    Inverse: 'Inverse',
    tips: 'Please note that the above exchange rate refreshes every two minutes',
    input: 'Please enter',
    select: 'Please select',
    cashExchange:'Foreign Currency Cash Exchange',
    enterCash:'Please enter the conversion amount',
    realtimeRate:'Real time exchange rate',
    transferService:'International Transfer Service',

  },
  // 联系我们
  contactUs: {
    Australianoffice: 'Australian office',
    SydneyRetailBranch: 'Sydney Retail Branch',
    ContactUs: 'Contact Us',
    Name: 'name',
    Phone: 'phone',
    Email: 'email',
    Purpose: 'Your purpose',
    ContactNumber: 'Contact number',
    message: 'Comments',
    Submitt: 'Submit',
    Address: 'address',
    EmailAddress: 'email',
    OpenTime: 'trading hours',
    ContactWay: 'Contact Way',
    BusinessConsulting: 'Business Consulting',
    'Coo&Con': 'Coo&Con',
    callTips: 'You can call our contact information directly.\n' +
      'I\'m so glad to hear from you',
    cooTips: 'Please complete this form and press the Confirm button\n' +
      'We\'ll get back to you as soon as possible',
    publicAccount: 'Kunda Suhui public account',
    storeName: 'Kunda Chatswood store'
  },
  // 在线开户
  openAccount: {
    RemittanceForm: 'REMITTANCE FORM',
    CustomerRegistrationAuthorizationForm: 'CUSTOMER REGISTRATION AND AUTHORISATION FORM',
    BusinessCustomerRegistrationForm: 'BUSINESS CUSTOMER REGISTRATION FORM'
  },
  // 表格
  table: {
    firstName: 'First name',
    lastName: 'Last name',
    yourCompanyName: 'Your company name',
    FillInTheEnterpriseNumber: 'Fill in the Enterprise Number',
    YourCareer: 'Your career',
    FillInTheEmail: 'Fill in the email',
    FillInThePhoneNumber: 'Fill in the phone number',
    FillInTheCertificationType: 'Fill in the certificate type',
    FillInTheDocumentNumber: 'Fill in the document Number',
    FillInTheFullAddress: 'Fill in the full address',
    FillOutThePurpose: 'Fill out the purpose',
    FillInTheBenchmarkCurrency: 'Fill in the benchmark currency',
    FillInTheTargetCurrency: 'Fill in the target currency',
    PaymentMethod: 'Payment method',
    NameOfPayee: 'Name of payee',
    RelationshipWithSender: 'Relationship with sender',
    ContactTelephoneNumber: 'Contact telephone number',
    FillInTheBankName: 'Fill in the bank name',
    FillInTheBankAccountNumber: 'Fill in the bank account number',
    FillInTheBankAddress: 'Fill in the bank address',
    FillInTheInternationalSettlementAccountNumber: 'Fill in the international settlement account number',
    PleaseSelect: 'Please select',
    FillInThePassportOrDriversLicenseIssuingAgency: 'Fill in the passport/driver\'s license issuing agency',
    FillInTheFullName: 'Fill in the full name',
    UploadIDPhotos: 'Upload ID Photos',
    Front: '(front)',
    Back: '(back)',
    UploadPhotos: 'Upload Photos',
    ClickOnTheUpload: 'Click on the upload',
    // 客户授权认证表
    AccountName: 'Fill in the account name',
    BankBranchCode: 'Fill in the bank branch code',
    swiftCode: 'Fill in the swift code',

    // 企业开户信息表
    registrationNumber: 'Fill in the enterprise registration number',
    contractName: 'Enter the contact name',
    fax: 'Fill in the fax',
    position: 'Fill in the position',
    name: 'Fill in the name',
    datePicker: 'Year/month/day',
    license: 'Fill in your passport/driver\'s license number'

  },
  // 表单校验
  formData: {
    email: 'The email cannot be empty',
    emailFormat: 'The format of the entered email is incorrect',
    type: 'The sender type cannot be empty',
    firstName: 'The first name cannot be empty',
    lastName: 'The last name cannot be empty',
    name: 'The name cannot be empty',
    birth: 'The date of birth cannot be empty',
    occupation: 'Careers can\'t be empty',
    phone: 'The phone number cannot be empty',
    idType: 'The ID type cannot be empty',
    idNumber: 'The ID number cannot be empty',
    expireDate: 'The validity period cannot be empty',
    address: 'The detailed address cannot be empty',
    source: 'The source of funds should not be empty',
    purpose: 'The purpose of remittance cannot be empty',
    baseCurrency: 'The base currency cannot be empty',
    targetCurrency: 'The target currency cannot be empty',
    paymentMethod: 'The payment method cannot be empty',
    payeeName: 'The payee name cannot be blank',
    relationship: 'The relationship with the remitter should not be empty',
    contactNumber: 'The contact number cannot be empty',
    recipientAddress: 'The detailed address cannot be empty',
    bankName: 'The bank name cannot be empty',
    bankAccountNumber: 'The account number cannot be empty',
    bankAddress: 'The bank address cannot be empty',
    optionalCode: 'The international settlement account number cannot be empty',
    customerType: 'The customer type cannot be empty',
    customerIdType: 'The ID type cannot be empty',
    customerIdIssue: 'Passport/driver\'s license issuing agency cannot be empty',
    frontPhotoFirst: 'The front of the driver\'s license must not be empty',
    backPhotoFirst: 'The back of the driver\'s license must not be empty',
    handPhoto: 'The selfie in my passport cannot be empty',
    frontPhoto: 'The front of the certificate must not be empty',
    backPhoto: 'The reverse side of the certificate cannot be empty',
    proofType: 'The letter cannot be empty',
    proofPhoto: 'A bank statement cannot be empty',
    otherFiles: 'Other attachments cannot be empty',
    customerName: 'The full name cannot be empty',
    signature: 'The customer signature cannot be empty',
    date: 'The date cannot be null',
    // 客户授权认证表
    gender: 'The gender cannot be null',
    accountName: 'The account name cannot be empty',
    bankBranchCode: 'The bank branch code cannot be empty',
    swiftCode: 'The swift code cannot be empty',

    // 企业开户信息表
    companyName: 'The company name cannot be empty',
    companyNumber: 'The enterprise registration number cannot be empty',
    contractName: 'The contact name cannot be empty',
    fax: 'The fax cannot be empty',
    position: 'The position should not be empty',
    license: 'Passport/driver\'s license number cannot be empty',
    licenseExpireDate: 'Passport/driver\'s license cannot be valid',

    // 客户签名
    signName: 'Please sign the customer\'s name',
    agreeTerms: 'Please agree to the terms of the privacy policy',
    submit: 'Submitted successfully',

    // 隐私政策
    agree: 'I have read and agree to the ',
    privacyPolicy: '《Privacy Policy Terms and Conditions》',
    confirmAbove: ', and confirm that the above information and documents provided are true and correct.'
  },
  // date Picker Options
  datePicker: {
    today: 'today',
    yesterday: 'yesterday',
    aWeeksAgo: 'a weeks ago'
  }
}

export default en



// WEBPACK FOOTER //
// ./src/project/i18n/langs/en.js